import React from 'react';

export default function BlogTextBlock({ data }) {
  const { heading, body, pullQuote, columns } = data;
  const bodyClass = `blog-text-body${columns === 2 ? ' blog-text-body--2col' : ''}`;

  return (
    <div className="blog-text-block">
      {heading && <h2 className="blog-text-heading">{heading}</h2>}
      {body && (
        <div className={bodyClass}>
          {body.split('\n\n').map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      )}
      {pullQuote && (
        <blockquote className="blog-text-inline-quote">
          <p>{pullQuote}</p>
        </blockquote>
      )}
    </div>
  );
}
